export const prefix =
  import.meta?.env?.MODE === 'development'
    ? REACT_APP_ENV.REACT_APP_BRANCH ?? import.meta.env.REACT_APP_BRANCH
    : REACT_APP_ENV.PUBLIC_URL ?? import.meta.env.PUBLIC_URL;
export const urlPrefix = prefix ? `/${prefix.replace(/^\/|\/$/g, '')}/` : '/';

export const RoutePath = {
  HOME: `${urlPrefix}`,
  ACCOUNT: `${urlPrefix}account`,
  ICONS_SHOW_ALL: `${urlPrefix}iconsShowAll`,
  ERROR_PAGE: `${urlPrefix}error`,
  DICTIONARY_REPORT: `${urlPrefix}dictionary/report`,
  DICTIONARY_REPORT_VERSION: `${urlPrefix}dictionary/reportVersion`,
  DICTIONARY_REPORT_PERIODS: `${urlPrefix}dictionary/reportPeriods`,
  DICTIONARY_REPORT_SETTINGS: `${urlPrefix}dictionary/reportSettings`,
  DICTIONARY_CONTROLS: `${urlPrefix}dictionary/controls`,
  DICTIONARY_CONTROL_GROUPS: `${urlPrefix}dictionary/controlGroups`,
  DICTIONARY_INDICATORS: `${urlPrefix}dictionary/indicators`,
  DICTIONARY_CONTROL_VERSIONS: `${urlPrefix}dictionary/controlVersions`,
  DICTIONARY_CONTROL_APPLICABILITY: `${urlPrefix}dictionary/controlApplicability`,
  DICTIONARY_REPORT_GROUPS: `${urlPrefix}dictionary/reportGroups`,
  ORGANIZATION_CARD: `${urlPrefix}organizations/card`,
  PREPARATION_OF_REPORTS: `${urlPrefix}preparationOfReports`,
  REPORTING_TREE: `${urlPrefix}reportingTree`,
  REPORTS: `reports`,
  ORGANIZATIONS: `${urlPrefix}organizations`,
  LOGS: `${urlPrefix}logs`,
  DATA_CONTROL: `${urlPrefix}dataControl`,
  DICTIONARY_COUNTERPARTIES: `${urlPrefix}dictionary/counterparties`,
  AUDIT: `${urlPrefix}audit`,
  USER_ROLE_REPORT: `${urlPrefix}userRoleReport`,
  SETTING_USER_ROLES: `${urlPrefix}settingUserRoles`,
  SETTINGS: `${urlPrefix}settings`,
};
